import { getAssetDisplayLabel } from "../const";
import { trimInsignificantAmountZeros } from "./amount";
/**
 * SEP-24 amounts (amount_in / amount_out / amount_fee) arrive as decimal
 * strings. Render them up to MAX_DISPLAY_DECIMALS so 6-decimal amounts are
 * never rounded away, then trim insignificant trailing zero padding.
 */
var MAX_DISPLAY_DECIMALS = 7;
var formatAmount = function (amount, amountAsset) {
    var assetCode = (amountAsset === null || amountAsset === void 0 ? void 0 : amountAsset.split(":")[1]) || amountAsset || "";
    var truncatedAmount = amount || "";
    if (truncatedAmount && !isNaN(Number(truncatedAmount))) {
        var _a = truncatedAmount.split("."), intPart = _a[0], decPart = _a[1];
        if (decPart) {
            truncatedAmount = trimInsignificantAmountZeros("".concat(intPart, ".").concat(decPart.slice(0, MAX_DISPLAY_DECIMALS)));
        }
    }
    // USDT0 is shown as "USDT"; other codes are printed as they arrive.
    var label = assetCode === "native"
        ? "XLM"
        : assetCode.toUpperCase() === "USDT0"
            ? getAssetDisplayLabel(assetCode)
            : assetCode;
    return "".concat(truncatedAmount, " ").concat(label);
};
var formatAddress = function (address) {
    return "".concat(address.slice(0, 6), "...").concat(address.slice(-4));
};
export { formatAddress, formatAmount };
